<script setup lang="ts">
import { computed, ref } from 'vue';
import { AffinityBanner, useAffinityStore } from '@/features/Affinity';
import { HeedHelpContactUs } from '@/features/HeedHelpContactUs';
import { useGlobalEventEmitter } from '@/shared/composables';
import { BaseModal } from '@/shared/ui/BaseModal';
import { NeedHelpIcon } from '@/shared/ui/icons';

const showHelpPopup = ref(false);

const eventEmitter = useGlobalEventEmitter();

const openHelpPopup = () => (showHelpPopup.value = true);
eventEmitter.on('open:contact-us', openHelpPopup);
const closeHelpPopup = () => (showHelpPopup.value = false);

const affinityStore = useAffinityStore();
const affinityLogo = computed(() => affinityStore.state.affinity?.logo ?? '');
</script>

<template>
  <AffinityBanner
    v-if="affinityLogo || affinityStore.affinityLoading"
    :logo="affinityLogo"
    :loading="affinityStore.affinityLoading"
  />

  <div class="footer-widget__help-popup__btn" @click="openHelpPopup">
    <NeedHelpIcon />
    {{ $t('qic.help.footerlink') }}
  </div>

  <BaseModal v-if="showHelpPopup" :is-open="showHelpPopup" @close="closeHelpPopup">
    <HeedHelpContactUs @close="closeHelpPopup" />
  </BaseModal>
</template>

<style scoped lang="scss">
@use 'FooterWidget';
</style>
